import React, { useEffect, useState } from "react";
import Nav from "../components/navbar";
import { UserAuth } from "../context/authContext";
import {
  query,
  collectionGroup,
  orderBy,
  doc,
  onSnapshot,
  updateDoc,
  increment,
  deleteDoc,
  where,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase-config";
import { MdDelete } from "react-icons/md";
import { BiEdit } from "react-icons/bi";
import parse from "html-react-parser";
import moment from "moment";
import {
  AiFillLinkedin,
  AiFillInstagram,
  AiFillTwitterSquare,
  AiFillEdit,
} from "react-icons/ai";
import { FaGithubSquare, FaBirthdayCake } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import empty from "../assets/empty.json";
import Lottie from "lottie-react";
import Minipost from "../components/minipost";

function Profile() {
  const { user } = UserAuth();
  const [posts, setPosts] = useState([]);
  const [name, setName] = useState("");
  const [birthdate, setBirthDate] = useState("");
  const [occupation, setOccupation] = useState("");
  const [insta, setInsta] = useState("");
  const [twitter, setTwitter] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [github, setGithub] = useState("");
  const [profile, setProfile] = useState("");
  const [bio, setBio] = useState("");

  const [loader, setLoader] = useState(true);

  const getPosts = async () => {
    const postsQuery = query(
      collectionGroup(db, "Posts"),
      where("publishedBy", "==", user.uid)
    );

    onSnapshot(postsQuery, (Querysnap) => {
      const posties = [];
      Querysnap.docs.forEach((doc) => {
        posties.push({ id: doc.id, data: doc.data() });
      });
      setPosts(posties);
      setLoader(false);
    });
  };

  useEffect(() => {
    getPosts();
  }, []);

  const getUser = async () => {
    const userRef = doc(db, "users", user.uid);
    let prof = null;
    let nom = null;
    let twitt = null;
    let git = null;
    let link = null;
    let inst = null;
    let occ = null;
    let birth = null;
    let bi = null;

    await getDoc(userRef).then((snapshot) => {
      prof = snapshot.data().profilePic;
      nom = snapshot.data().username;
      twitt = snapshot.data().twitterURL;
      git = snapshot.data().githubURL;
      link = snapshot.data().linkedin;
      inst = snapshot.data().instaURL;
      occ = snapshot.data().occupation;
      birth = snapshot.data().birthDate;
      bi = snapshot.data().bio;
    });
    setProfile(prof);
    setName(nom);
    setTwitter(twitt);
    setGithub(git);
    setLinkedin(link);
    setInsta(inst);
    setOccupation(occ);
    setBirthDate(birth);
    setBio(bi);
  };

  useEffect(() => {
    getUser();
  }, []);

  const getShortVesr = (unparsedText) => {
    let newText = unparsedText.substring(0, 330) + "...";
    return parse(newText);
  };

  const getShortTitle = (unparsedText) => {
    let newText = unparsedText.substring(0, 40) + "...";
    return newText;
  };

  const deletePost = async (useId, cat, pstid) => {
    const postRef = doc(db, "users", useId, "Categories", cat, "Posts", pstid);

    await deleteDoc(postRef);

    const count = "count";
    const colRef = doc(
      db,
      "users",
      useId,
      "Categories",
      cat,
      "Posts",
      pstid,
      "postComments",
      count
    );

    await updateDoc(colRef, {
      count: increment(-1),
    });
  };

  let navigate = useNavigate();

  const routeChange = (titre, identifier) => {
    const nav = `/post/${titre}=${identifier}`;
    navigate(nav);
  };

  return (
    <div className="mainWrapper">
      <Nav />
      <div className="innerwrapper overflow-y-auto p-0  bgAccount flex flex-row">
        <div className="h-full w-[65%] py-5 pl-10 flex flex-col">
          <motion.div
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: -30 }}
            transition={{ ease: "easeOut", duration: 0.5 }}
          >
            <div className="text-OrangyRed font-semibold text-xl">Profile</div>
            <div className="text-zinc-500 font-medium mt-1">
              Edit & Delete any of your listed posts
            </div>
            <div className="w-56 h-1 mt-3 bg-[#202020] bg-opacity-30"></div>
          </motion.div>
          <div className="w-full h-full flex flex-col overflow-y-auto mt-4 gap-3">
            {posts.length > 0 ? (
              posts.map((pst, index) => (
                <Minipost
                  postid={pst.id}
                  ind={index}
                  title={pst.data.title}
                  tumbnail={pst.data.tumbnailURL}
                  publishedby={pst.data.publishedBy}
                  category={pst.data.category}
                  content={pst.data.content}
                  commentscount={pst.data.commentsCount}
                />
              ))
            ) : (
              <motion.div
                className=" pb-10 relative w-full h-full flex flex-col items-center justify-center font-semibold text-zinc-500"
                animate={{ opacity: 1 }}
                initial={{ opacity: 0 }}
                transition={{
                  ease: "easeIn",
                  duration: 0.5,
                  delay: 0.3,
                }}
                exit={{ opacity: 0 }}
              >
                <Lottie
                  animationData={empty}
                  loop={true}
                  style={{ width: "55%" }}
                />
                <div className=" absolute left-1/2 -translate-x-1/2 bottom-[7.5rem] text-zinc-500 font-semibold">
                  There aren't any publications to display yet!
                </div>
              </motion.div>
            )}
          </div>
        </div>
        <div className="h-full w-[35%] flex flex-col justify-between">
          <div className="w-full h-[80%] rounded-2xl flex flex-col justify-between">
            <div className="w-full h-44 flex flex-row">
              {profile && (
                <motion.div
                  className="w-[35%] h-full flex flex-col items-center justify-end pb-4 rounded-b-full bg-[#141414]"
                  animate={{ opacity: 1, y: 0 }}
                  initial={{ opacity: 0, y: -30 }}
                  transition={{ ease: "easeOut", duration: 0.5, delay: 0.3 }}
                >
                  <div className="w-28 h-28  rounded-full overflow-hidden">
                    <img
                      src={profile}
                      referrerPolicy="no-referrer"
                      alt="profile pic"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </motion.div>
              )}
              <motion.div
                className="w-[65%] h-full flex flex-col pt-5 pl-4"
                animate={{ opacity: 1, x: 0 }}
                initial={{ opacity: 0, x: -30 }}
                transition={{ ease: "easeOut", duration: 0.4, delay: 0.5 }}
              >
                <div className="text-xl font-semibold text-zinc-100 capitalize">
                  {name}
                </div>
                {occupation ? (
                  <div className=" text-zinc-500 font-medium mt-6 flex flex-row items-center">
                    <MdWork size={20} className="fill-OrangyRed mr-3" />
                    {occupation}
                  </div>
                ) : (
                  <></>
                )}
                {birthdate ? (
                  <div className="flex flex-row mt-2 text-zinc-500 font-medium items-center">
                    <FaBirthdayCake size={20} className="fill-OrangyRed mr-3" />
                    {moment(new Date(birthdate)).format("MMMM D, YYYY")}
                  </div>
                ) : (
                  <></>
                )}
              </motion.div>
            </div>
            <div className="h-[18rem] w-full pr-4">
              <motion.div
                className="bg-[#141414] w-full h-full rounded-2xl flex flex-col justify-between overflow-hidden"
                animate={{ opacity: 1, scale: 1 }}
                initial={{ opacity: 0, scale: 0.8 }}
                transition={{ ease: "easeOut", duration: 0.4, delay: 0.8 }}
              >
                {bio ? (
                  <div className="w-full h-[77%] flex flex-col p-7">
                    <div className="text-zinc-500 font-semibold">About:</div>
                    <div className="mt-2 text-zinc-200 ">{bio}</div>
                  </div>
                ) : (
                  <div className="w-full h-[77%] flex flex-col justify-center items-center p-7 text-zinc-500 font-semibold">
                    you have no bio!
                  </div>
                )}
                <div className="w-full h-[25%] bg-[#121212] rounded-t-full relative flex flex-row items-center justify-around">
                  <div className="py-2 px-4 bg-[#161616] absolute -top-6 text-sm text-zinc-500 rounded-xl font-semibold left-1/2 transform -translate-x-1/2">
                    Social Links
                  </div>
                  {!insta && !twitter && !github && !linkedin ? (
                    <div className="w-full h-full flex items-center justify-center text-zinc-500 font-semibold">
                      you have no social links!
                    </div>
                  ) : (
                    <div className="w-full h-full flex flex-row items-center justify-around">
                      {insta && (
                        <a
                          href={insta}
                          target="_blank"
                          rel="noreferrer"
                          className="transition ease-in-out hover:scale-110"
                        >
                          <AiFillInstagram
                            size={30}
                            className="fill-OrangyRed"
                          />
                        </a>
                      )}
                      {twitter && (
                        <a
                          href={twitter}
                          target="_blank"
                          rel="noreferrer"
                          className="transition ease-in-out hover:scale-110"
                        >
                          <AiFillTwitterSquare
                            size={30}
                            className="fill-OrangyRed"
                          />
                        </a>
                      )}
                      {github && (
                        <a
                          href={github}
                          rel="noreferrer"
                          target="_blank"
                          className="transition ease-in-out hover:scale-110"
                        >
                          <FaGithubSquare
                            size={27}
                            className="fill-OrangyRed"
                          />
                        </a>
                      )}
                      {linkedin && (
                        <a
                          href={linkedin}
                          rel="noreferrer"
                          target="_blank"
                          className="transition ease-in-out hover:scale-110"
                        >
                          <AiFillLinkedin
                            size={30}
                            className="fill-OrangyRed"
                          />
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </motion.div>
            </div>
          </div>
          <motion.div
            className="w-56 self-end h-[13%] bg-[#141414] my-4 rounded-l-full flex flex-row items-center justify-center hover:bg-[#121212] transition-all ease-in-out"
            animate={{ opacity: 1, x: 0 }}
            initial={{ opacity: 0, x: 30 }}
            transition={{ ease: "easeOut", duration: 0.5, delay: 1 }}
          >
            {" "}
            <Link
              to="/account"
              className="w-full h-full flex flex-row items-center justify-center"
            >
              <AiFillEdit size={27} className="fill-OrangyRed mr-3" />
              <div className="text-lg font-semibold text-OrangyRed">
                Edit Profile
              </div>
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
